import arrayMap from './_arrayMap.js';

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

export default baseValues;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_baseValues.js
// module id = 469
// module chunks = 30 31 32 33 34